import { ExtendedWarrantiesUI } from "./ExtendedWarrantiesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { VariantServices } from "../../types/types";
import { dispatchAnalyticsEvent } from "../../utils";

export function ExtendedWarranties({
  product,
}: Pick<StandardProps, "product" | "configProps">) {
  const { variant } = useVariant(product);

  const extendedWarrantyServices = variant?.services?.filter(({ __typename }) =>
    ["DeliveryService", "ExtendedWarranty"].includes(__typename),
  ) as VariantServices;

  const hasWarranties = (extendedWarrantyServices ?? []).length > 0;

  const extendedWarrantiesAnalyticsHandler = (warrantyTitle: string) => {
    dispatchAnalyticsEvent(
      "pdp.modalUpdated",
      {
        type: "addToBasketService",
        services: [
          {
            price: variant.price?.value,
            productId: product.aliases.pimProductId,
            sku: variant.aliases.skuId,
            type: warrantyTitle,
          },
        ],
      },
      {},
    );
  };

  if (!hasWarranties) return null;

  return (
    <ExtendedWarrantiesUI
      availableToOrder={variant?.availability?.availableToOrder || false}
      variantServices={extendedWarrantyServices}
      extendedWarrantiesAnalyticsHandler={extendedWarrantiesAnalyticsHandler}
    />
  );
}
